(function($, exports) {
	exports.init = function() {
		document.addEventListener(
			'wpcf7mailsent',
			function(event) {
				var form = $('.wpcf7-form');

				$.ajax({
					type: 'POST',
					url: '/mollie/create-order.php',
					data: form.serializeArray(),
					success: function(data) {
						location.href = data;
					},
					error: function(data) {
						alert(
							'Er is iets mis gegaan met de verwerking van het betalingssysteem.'
						);
						console.log(data);
					},
				});
			},
			false
		);
	};
})(jQuery, (this.SIGNUPFORM = {}));
